<template>
	<transition name="slide-fade">
		<div class="modal-container" @click="closeModal">
			<div class="modal" @click.stop>
				<div class="modal-header">
					<div class="modal-title">
						<!-- <span>
                            <ion-icon name="ios-notifications"></ion-icon>
						</span>-->
						<span>Notifications</span>
					</div>
					<div class="close" title="close">
						<ion-icon name="ios-close" @click="closeModal"></ion-icon>
					</div>
				</div>
				<div class="modal-body">
					<notifications-list v-if="unseenNotifs.length > 0" :notifs="unseenNotifs"></notifications-list>
					<no-content v-else :header="noContentHeader" :paragraph="noContentParagraph"></no-content>
				</div>
				<div class="modal-footer"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import NoContent from "../errors/NoContent.vue";
import NotificationsList from "../notifications/NotificationsList.vue";

export default {
	data() {
		return {
			noContentHeader: "You do not have any notifications",
			noContentParagraph: "Check again later",
			notifications: []
		};
	},
	components: {
		NoContent,
		NotificationsList
	},
	computed: {
		unseenNotifs() {
			return this.$store.getters.getNotifications;
		}
	},
	methods: {
		closeModal() {
			const html = document.querySelector("html");
			const modalContainer = document.querySelector(".modal-container");
			const app = document.querySelector("#app");
			app.classList.remove("blur-app");
			modalContainer.removeEventListener("click", this.closeModal);
			html.style.overflowY = "scroll";

			this.$store.commit("updateNotificationsModal", false);
		}
	}
};
</script>

<style lang="css" src="../../styles/modalStyles.css" scoped></style>
<style scoped>
/* .modal-title span:first-of-type {
        background-color: #171717;
        padding: 0px;
        vertical-align: middle;
    } */
.modal {
	padding: 20px 0px;
}

.modal-header {
	padding: 0px 20px;
}

/* .modal-body {
        padding-right: 20px;
    } */
</style>



// WEBPACK FOOTER //
// src/components/modals/NotificationsModal.vue